// import React from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Row,
//   Col,
//   Button,
//   Card,
//   CardBody,
// } from "reactstrap";

// const InfoRow = ({ label, value }) => (
//   <Row className="mb-3">
//     <Col md={5}>
//       <h6 className="fw-semibold text-muted mb-1">{label}</h6>
//     </Col>
//     <Col md={7}>
//       <p className="fw-medium text-dark mb-0">
//         {value ? value : <span className="text-muted">-</span>}
//       </p>
//     </Col>
//   </Row>
// );

// const ViewBookedTripModal = ({ show, toggle, trip }) => {
//   if (!trip) return null;

//   return (
//     <Modal isOpen={show} toggle={toggle} centered size="lg">
//       <ModalHeader toggle={toggle}>Booked Trip Details</ModalHeader>

//       <ModalBody>
//         <Card className="shadow-sm border-0">
//           <CardBody>
//             <Row>
//               <Col md={6}>
//                 <InfoRow label="Trip No" value={trip.tripNo} />
//                 <InfoRow label="Session" value={trip.sessionName} />
//                 <InfoRow label="Customer" value={trip.customerName} />
//                 <InfoRow label="Supplier" value={trip.suppliersName} />
//                 <InfoRow label="Vehicle No" value={trip.vehicleNo} />
//                 <InfoRow label="Trip Type" value={trip.tripType} />
//                 <InfoRow label="Party Type" value={trip.partyType} />
//               </Col>

//               <Col md={6}>
//                 <InfoRow label="Invoice No" value={trip.invoiceNo} />
//                 <InfoRow label="KM / Trip" value={trip.kmOrTrip} />
//                 <InfoRow label="Rate" value={trip.rate} />
//                 <InfoRow label="Amount" value={trip.amount} />
//                 <InfoRow label="Toll Charges" value={trip.tollCharges} />
//                 <InfoRow label="Other Charges" value={trip.otherCharges} />
//                 <InfoRow
//                   label="Handling Charges"
//                   value={trip.handlingCharges}
//                 />
//                 <InfoRow label="Trip Date" value={trip.tripDate} />
//               </Col>
//             </Row>
//           </CardBody>
//         </Card>

//         <div className="text-end mt-3">
//           <Button color="secondary" onClick={toggle}>
//             Close
//           </Button>
//         </div>
//       </ModalBody>
//     </Modal>
//   );
// };

// export default ViewBookedTripModal;

import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  ModalFooter,
} from "reactstrap";

const InfoRow = ({ label, value }) => (
  <Row className="mb-3">
    <Col md={5}>
      <h6 className="text-muted mb-1">{label}</h6>
    </Col>
    <Col md={7}>
      <p className="fw-medium text-dark mb-0">
        {value ? value : <span className="text-muted">-</span>}
      </p>
    </Col>
  </Row>
);

const ViewBookedTripModal = ({ show, toggle, trip }) => {
  if (!trip) return null;

  return (
    // <Modal
    //   isOpen={show}
    //   toggle={toggle}
    //   centered
    //   size="lg"
    //   className="shadow-none border-0"
    // >
    //   <ModalHeader toggle={toggle} className="bg-light text-dark py-3">
    //     <h5 className="mb-0">Booked Trip Details</h5>
    //   </ModalHeader>

    //   <ModalBody className="px-4 py-4">
    //     <Card className="shadow-sm border-0">
    //       <CardBody className="p-4">
    //         <Row>
    //           <Col md={6}>
    //             <InfoRow label="Trip No" value={trip.tripNo} />
    //             <InfoRow label="Session" value={trip.sessionName} />
    //             <InfoRow label="Customer" value={trip.customerName} />
    //             <InfoRow label="Supplier" value={trip.suppliersName} />
    //             <InfoRow label="Vehicle No" value={trip.vehicleNo} />
    //             <InfoRow label="Trip Type" value={trip.tripType} />
    //             <InfoRow label="Party Type" value={trip.partyType} />
    //           </Col>

    //           <Col md={6}>
    //             <InfoRow label="Invoice No" value={trip.invoiceNo} />
    //             <InfoRow label="KM / Trip" value={trip.kmOrTrip} />
    //             <InfoRow label="Rate" value={trip.rate} />
    //             <InfoRow label="Amount" value={trip.amount} />
    //             <InfoRow label="Toll Charges" value={trip.tollCharges} />
    //             <InfoRow label="Other Charges" value={trip.otherCharges} />
    //             <InfoRow
    //               label="Handling Charges"
    //               value={trip.handlingCharges}
    //             />
    //             <InfoRow label="Trip Date" value={trip.tripDate} />
    //           </Col>
    //         </Row>
    //       </CardBody>
    //     </Card>

    //     <div className="text-end mt-3">
    //       <Button color="secondary" onClick={toggle} className="btn-sm">
    //         Close
    //       </Button>
    //     </div>
    //   </ModalBody>
    // </Modal>

    <Modal isOpen={show} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Booked Trip Details</ModalHeader>

      <ModalBody>
        <div className="p-3">
          {/* SECTION: TRIP INFO */}
          <h6 className="text-uppercase text-muted mb-2">Trip Information</h6>
          <div className="border rounded p-3 mb-3 bg-light">
            <Row className="g-3">
              <Col md={6}>
                <strong>Trip No:</strong> {trip?.tripNo}
              </Col>
              <Col md={6}>
                <strong>Invoice No:</strong> {trip?.tripInvoiceNo}
              </Col>

              <Col md={6}>
                <strong>Session:</strong> {trip?.sessionName}
              </Col>
              <Col md={6}>
                <strong>KM / Trip:</strong> {trip?.kmOrTrip}
              </Col>

              <Col md={6}>
                <strong>Trip Type:</strong> {trip?.tripType}
              </Col>
              <Col md={6}>
                <strong>Party Type:</strong> {trip?.partyType}
              </Col>

              <Col md={12}>
                <strong>Trip Date:</strong> {trip?.tripDate}
              </Col>
            </Row>
          </div>

          {/* SECTION: CUSTOMER */}
          <h6 className="text-uppercase text-muted mb-2">Customer & Vehicle</h6>
          <div className="border rounded p-3 mb-3 bg-light">
            <Row className="g-3">
              <Col md={12}>
                <strong>Customer:</strong> {trip?.customerName}
              </Col>
              <Col md={12}>
                <strong>Supplier:</strong> {trip?.suppliersName}
              </Col>
              <Col md={12}>
                <strong>Vehicle No:</strong> {trip?.vehicleNo}
              </Col>
            </Row>
          </div>

          {/* SECTION: CHARGES */}
          <h6 className="text-uppercase text-muted mb-2">Charges</h6>
          <div className="border rounded p-3 bg-light">
            <Row className="g-3">
              <Col md={6}>
                <strong>Rate:</strong> ₹{trip?.rate}
              </Col>
              <Col md={6}>
                <strong>Amount:</strong> ₹{trip?.amount}
              </Col>

              <Col md={6}>
                <strong>Toll Charges:</strong> ₹{trip?.tollCharges}
              </Col>
              <Col md={6}>
                <strong>Other Charges:</strong> ₹{trip?.otherCharges}
              </Col>

              <Col md={12}>
                <strong>Handling Charges:</strong> ₹{trip?.handlingCharges}
              </Col>
            </Row>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button className="btn-sm" color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewBookedTripModal;
